<template>
  <div class="cont">
    <h1>{{ $t('cer.security')}}</h1>

    <div class="sertification-wrap">
        <div class="sertification-items">
            <div class="carousel">

                <div class="carousel-cer" v-for="(img, i) in images" :key="i">

                    <img 
                      :src="img" 
                      alt="Сертификат" 
                      :class="{ zoomed: zoomedIndex === i }"
                      @click="toggleZoom(i, img)"
                    />

                    <div v-if="isOpen" class="lightbox" @click="closeLightbox">
                      <img :src="currentImg" alt="" @click.stop />
                    </div>
                </div>

            </div>
        </div>
        
        <div class="sertification-content">
            <div class="sertification-description">
              {{ $t('cer.cer-discript') }}
            </div>
            
            <ul>
                <li class="sertification-list"><span class="number">1</span><span class="text">{{ $t('cer.title')}}</span></li>
                <li class="sertification-list"><span class="number">2</span><span class="text">{{ $t('cer.title1')}}</span></li>
                <li class="sertification-list"><span class="number">3</span><span class="text">{{ $t('cer.title2')}}</span></li>
            </ul>
            
            <div class="sertification-claim">
                {{ $t('cer.claim')}}
            </div>
            
            <div class="sertification-row">
                <h2>{{ $t('cer.rowh2')}}</h2>
                <p>
                    {{  $t('cer.rowp') }}
                </p>
            </div>
            
            <div class="sertification-row">
                <h2>{{ $t('cer.rowh22')}}</h2>
                <p>
                    {{ $t('cer.rowp2') }}
                </p>
            </div>
            
            <div class="sertification-row">
                <h2>{{ $t('cer.rowh23') }}</h2>
                <ul>
                    <li class="sertification-list"><span class="number">1</span><span class="text"><b>{{ $t('cer.text')}}</b></span></li>
                    <li class="sertification-list"><span class="text">{{ $t('cer.text1')}}</span></li>
                    <li class="sertification-list"><span class="number">2</span><span class="text"><b>{{ $t('cer.text2')}}</b></span></li>
                    <li class="sertification-list"><span class="text" v-html="$t('cer.text3')"></span></li>
                </ul>
            </div>
            
            <div class="sertification-row">
                <h2>{{ $t('cer.rowh24')}}</h2>
                <ul>
                    <li class="sertification-list"><span class="number">1</span><span class="text">{{ $t('cer.listtext')}}</span></li>
                    <li class="sertification-list"><span class="number">2</span><span class="text">{{ $t('cer.listtext1')}}</span></li>
                    <li class="sertification-list"><span class="number">3</span><span class="text">{{  $t('cer.listtext2') }}</span></li>
                    <li class="sertification-list"><span class="number">4</span><span class="text">{{  $t('cer.listtext3') }}</span></li>
                </ul>
            </div>
            
            <p><b>{{ $t('cer.pb')}}</b></p>
            
        </div>
    </div>
</div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "SafetyCertificationView",

  setup(_, { root }) {
    const isOpen = ref(false);
    const currentImg = ref("");
    const zoomedIndex = ref(null);

    const images = [
      "/img/ser1.png",
      "/img/ser2.png"
    ];

    function openLightbox(src) {
      currentImg.value = src;
      isOpen.value = true;
    }

    function closeLightbox() {
      isOpen.value = false;
    }

    function toggleZoom(index) {
      if (zoomedIndex.value === index) {
        zoomedIndex.value = null;
      } else {
        zoomedIndex.value = index;
      }
    }

    // --- метод смены языка ---
    function switchLang(lang) {
      root.$i18n.locale = lang;
    }

    return { 
      isOpen, currentImg, openLightbox, closeLightbox,
      zoomedIndex, toggleZoom, images,
      switchLang
    };
  }
};
</script>


<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", Arial, sans-serif;
}

body {
  color: #333;
  line-height: 1.6;
  background-color: #f9f9f9;
}

.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(117, 117, 117, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.lightbox img {
  max-width: 90%;
  max-height: 90vh;
  border-radius: 6px;
}

.cont {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

h1 {
  color: #0F8382;
  font-size: clamp(22px, 2vw, 36px);
  margin-bottom: 20px;
  font-weight: 500;
  text-align: center;
}

h2 {
  color: #0F8382;
  font-size: clamp(18px, 1.8vw, 24px);
  margin: 25px 0 15px;
  font-weight: 500;
}

p {
  margin-bottom: 20px;
  font-size: clamp(14px, 1.2vw, 16px);
}

.sertification-wrap {
  background: white;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  padding: 30px;
  margin-bottom: 40px;
}

.sertification-items {
  margin-bottom: 30px;
}

.carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  overflow-x: auto;
  padding: 10px 0;
  gap: 30px;
}

.carousel img {
  max-width: 100%;
  height: auto;
  max-height: 300px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s ease, max-height 0.3s ease;
}

.carousel img.zoomed {
  transform: scale(1.5);
  z-index: 5;
  max-height: 500px;
  position: relative;
}

.carousel img:hover {
  transform: scale(1.03);
}

.sertification-description {
  font-size: clamp(15px, 1.4vw, 18px);
  margin-bottom: 25px;
  color: #444;
}

.sertification-claim {
  font-size: clamp(15px, 1.4vw, 18px);
  font-style: italic;
  margin: 25px 0;
  color: #0F8382;
  padding-left: 15px;
  border-left: 3px solid #0F8382;
}

.sertification-list {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  font-size: clamp(14px, 1.2vw, 16px);
}

.sertification-list .number {
  background: #0F8382;
  color: white;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
  font-weight: bold;
  font-size: 14px;
}

.sertification-list .text {
  flex: 1;
}

.sertification-row {
  margin: 40px 0;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
}

.sertification-row h2 {
  background: #f5f5f5;
  padding: 15px 20px;
  margin: 0;
  display: flex;
  align-items: center;
}

.sertification-row ul {
  padding: 0 20px 20px 20px;
  margin: 0;
  list-style: none;
}

.sertification-row p {
  padding: 0 20px 20px;
  margin: 0;
}

.sertification-link {
  margin-top: 30px;
  text-align: center;
}

.sertification-link a {
  display: inline-block;
  background: #0F8382;
  color: white;
  padding: 12px 25px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.3s;
}

.sertification-link a:hover {
  background: #0c6d6d;
}

b {
  color: #0F8382;
}

/* === Адаптивность === */
@media (max-width: 1024px) {
  .carousel img {
    max-height: 300px;
  }
}

@media (max-width: 768px) {
  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 20px;
  }
  .sertification-wrap {
    padding: 20px 15px;
  }
  .carousel {
    gap: 20px;
  }
  .carousel img {
    max-height: 220px;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  .carousel img {
    max-height: 400px;
  }
  .sertification-claim {
    font-size: 14px;
  }
  .sertification-list .number {
    width: 20px;
    height: 20px;
    font-size: 12px;
  }
}

</style>